import { RootState } from '../rootReducer';

export const selectQuestionAnswer = (state: RootState) => state.questionAnswer.questionAnswer.questionAnswer;
